import {atom} from "recoil";


const cartItem = atom({
  key: 'cartItem',
  default: [],
 });


 export default cartItem;
